import KlaviyoTableReport from './KlaviyoTableReport';

const KlaviyoCampaignPerformanceReport = (props) => (
    <KlaviyoTableReport {...props} table="klaviyo_campaign_performance" />
);

export default KlaviyoCampaignPerformanceReport;
